module.exports = __webpack_public_path__ + "static/img/logo.1b0223ad.png";